"use client";

import React, { useState, useRef, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
const ingredients = [{
  id: 1,
  name: "Braised Pork Rice",
  description: "招牌卤肉饭 • $8.50",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/hokkaido_uni_floating.png"
}, {
  id: 2,
  name: "Soy Broth Noodles",
  description: "秘制豆乳汤 • $9.20",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/a5_wagyu_floating.png"
}, {
  id: 3,
  name: "Oyster Mee Sua",
  description: "蚵仔面线 • $7.80",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/fresh_shiso_floating.png"
}, {
  id: 4,
  name: "Signature Gua Bao",
  description: "大台北割包 • $6.50",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/bluefin_otoro_floating.png"
}, {
  id: 5,
  name: "Beef Noodle Soup",
  description: "红烧牛肉面 • $12.50",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/royal_caviar_floating.png"
}, {
  id: 6,
  name: "Fish Tempura",
  description: "大台北甜不辣 • $5.50",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/wasabi_root_floating.png"
}];
export default function ThePalette() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = scrollContainerRef.current;
      const maxScroll = scrollWidth - clientWidth;
      const progress = maxScroll > 0 ? scrollLeft / maxScroll * 100 : 0;
      setScrollProgress(progress);
    }
  };
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      handleScroll();
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return <section data-section-id="42109" id="the-daily-classics" className="bg-[#FDF0D5] text-[#023E8A] relative w-full overflow-hidden py-24 md:py-32">
      <div className="container mx-auto px-6 mb-12 md:mb-16">
        <div className="flex flex-col md:flex-row justify-between items-end gap-8">
          <div className="max-w-xl">
            <h2 className="text-5xl md:text-7xl font-sans font-black tracking-tighter mb-6 text-[#E63946] uppercase">
              Daily Classics / 每日精選
            </h2>
            <p className="text-[#023E8A]/70 text-xl font-medium leading-relaxed">
              Our most-loved Taiwanese staples, prepared fresh every day. 
              From the richness of our braised pork rice to the savory depth 
              of our signature soy broths—comfort in every bite.
            </p>
          </div>
          <div className="hidden md:block">
             <Button variant="outline" className="rounded-full border-[#E63946]/20 hover:bg-[#E63946]/10 hover:text-[#E63946] hover:border-[#E63946] transition-colors duration-500 text-[#023E8A]" asChild>
                <Link to="/GreatTaipeiPage">
                  See Full Menu / 完整菜單 <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
             </Button>
          </div>
        </div>
      </div>

      {}
      <div ref={scrollContainerRef} className="flex w-full overflow-x-auto snap-x snap-mandatory scrollbar-hide pb-16 px-6 md:px-12 gap-12 md:gap-32 items-center" style={{
      scrollbarWidth: "none",
      msOverflowStyle: "none"
    }}>
        {ingredients.map((item, i) => <div key={item.id} data-index={i} className="snap-center shrink-0 flex flex-col items-center justify-center w-[80vw] md:w-[40vw] lg:w-[30vw] group">
            <div className="relative aspect-square w-full flex items-center justify-center p-8 md:p-12 transition-transform duration-700 ease-out group-hover:scale-110">
              {}
              <img src={item.image} alt={item.name} className="w-full h-full object-contain drop-shadow-xl" loading="lazy" />
            </div>
            
            <div className="mt-8 text-center opacity-90 group-hover:opacity-100 transition-opacity duration-500">
              <h3 className="text-3xl md:text-4xl font-sans font-black text-[#023E8A] mb-2 uppercase tracking-tight">
                {item.name}
              </h3>
              <p className="text-[#E63946] font-mono text-xl font-bold tracking-tight uppercase">
                {item.description}
              </p>
            </div>
          </div>)}
        
        {}
        <div className="shrink-0 w-6 md:w-12" />
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full px-0">
        <Progress value={scrollProgress} className="h-[4px] w-full rounded-none bg-[#023E8A]/10 [&>[data-slot=progress-indicator]]:bg-[#E63946]" />
      </div>
      
      {}
      <div className="md:hidden flex justify-center mt-8 px-6">
         <Button variant="outline" className="w-full rounded-full border-[#E63946]/20 text-[#023E8A]" asChild>
            <Link to="/GreatTaipeiPage">
              See Full Menu / 完整菜單
            </Link>
         </Button>
      </div>
    </section>;
}